<template>
  <div class="form__section__wrap">
    <div class="form__section--left">
      <mailing-lists-column :mailing-lists="leftMailingLists"
                            @change="handleChange"
                            :data="data" />
    </div>
    <div class="form__section--right">
      <mailing-lists-column :mailing-lists="rightMailingLists"
                            @change="handleChange"
                            :data="data" />
    </div>
  </div>
</template>

<script>
import mailingListsColumn from './MailingListsColumn';
import mailingListsUtils from '../models/mailing-lists/utils.js';
import formElement from '../mixins/form-element';

export default {
  mixins: [formElement],
  components: {
    mailingListsColumn,
  },
  props: ['mailingLists', 'data'],
  computed: {
    leftMailingLists() {
      return this.predigest(this.mailingLists).left;
    },
    rightMailingLists() {
      return this.predigest(this.mailingLists).right;
    },
  },
  methods: {
    predigest(mailingLists) {
      const leftMailingLists = [];
      const rightMailingLists = [];

      let target = leftMailingLists;

      for (const firstLevelItem of mailingLists) {
        if (firstLevelItem.type === 'separator') {
          target = rightMailingLists;
          continue;
        }

        target.push(firstLevelItem);
      }

      return {
        left: leftMailingLists,
        right: rightMailingLists,
      };
    },
    handleChange({ id, value }) {
      this.$emit('change', { id, value });
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/MailingLists.vue